import React from "react";
import { MoleculePoster } from "./MoleculePoster";

/**
 * Compact molecule thumbnail for cart/checkout line items. Renders the same
 * instant static poster used on product cards — zero JS, zero network, zero wait.
 */
export const MoleculeThumb = ({ molecule, className = "" }) => {
    if (!molecule) {
        return (
            <div className={`flex items-center justify-center bg-ink-base ${className}`}>
                <svg viewBox="0 0 40 40" className="w-1/2 h-1/2 opacity-40" aria-hidden="true">
                    <circle cx="20" cy="20" r="18" fill="none" stroke="#10b981" strokeOpacity="0.3" strokeWidth="1" />
                    {[0, 72, 144, 216, 288].map((a, i) => {
                        const rad = (a * Math.PI) / 180;
                        const x = 20 + Math.cos(rad) * 10;
                        const y = 20 + Math.sin(rad) * 10;
                        return <circle key={i} cx={x} cy={y} r="3" fill="#10b981" fillOpacity="0.5" />;
                    })}
                </svg>
            </div>
        );
    }
    return <MoleculePoster molecule={molecule} className={className} />;
};
